import React from "react";
import { Controller } from "react-hook-form";
import { advancedFiltersDateFields, searchAdvancedFiltersFields } from "../../task-list/lib/constants";
import { DatePicker, Select, Textarea } from "../../form-inputs/inputs";
import { statusBooleanOptions } from "../../../shared/constants/dropdown-options";
import { useAdvancedFiltersForm } from "../../../shared/hooks/use-advanced-filters-form";
import { useClients } from "../hooks/use-clients";
import MultiSelectList from "../../form-inputs/custom/react-multi-select";

export const NonAdminSearchForm = () => {
    const { control, findDefaultValues } = useAdvancedFiltersForm();
    const { data: cxhClients } = useClients(3);
    const { data: clients } = useClients(2);

    return (
        <>
            <div className="advanced-filters-row -align-start">
                <div className="advanced-filters-name flex-1">{searchAdvancedFiltersFields.upc.label}</div>
                <Controller
                    name={searchAdvancedFiltersFields.upc.name}
                    control={control}
                    render={({ field }) => (
                        <Textarea
                            {...field}
                            className="flex-2 advanced-filters-field"
                        />
                    )}
                />
            </div>
            <div className="advanced-filters-row -align-start">
                <div className="advanced-filters-name flex-1">{searchAdvancedFiltersFields.cxhClient.label}</div>
                <Controller
                    name={searchAdvancedFiltersFields.cxhClient.name}
                    control={control}
                    render={({ field }) => {
                        return (
                            <div className="flex-2 advanced-filters-field">
                                <MultiSelectList
                                    autoCloseClassName=".advanced-filters-body"
                                    defaultValue={findDefaultValues(cxhClients, field.value)}
                                    name={searchAdvancedFiltersFields.cxhClient.label}
                                    options={cxhClients}
                                    updateOnChange={(name, values) => field.onChange(values)}
                                    clearSelections={field.value === ""}
                                />
                            </div>
                        );
                    }}
                />
            </div>
            <div className="advanced-filters-row -align-start">
                <div className="advanced-filters-name flex-1">{searchAdvancedFiltersFields.gdnClient.label}</div>
                <Controller
                    name={searchAdvancedFiltersFields.gdnClient.name}
                    control={control}
                    render={({ field }) => {
                        return (
                            <div className="flex-2 advanced-filters-field">
                                <MultiSelectList
                                    autoCloseClassName=".advanced-filters-body"
                                    defaultValue={findDefaultValues(clients, field.value)}
                                    name={searchAdvancedFiltersFields.gdnClient.label}
                                    options={clients}
                                    updateOnChange={(name, values) => field.onChange(values)}
                                    showPagination={false}
                                    clearSelections={field.value === ""}
                                />
                            </div>
                        );
                    }}
                />
            </div>

            <div className="advanced-filters-row -align-start">
                <div className="advanced-filters-name flex-1">{searchAdvancedFiltersFields.binTrackingNumber.label}</div>
                <Controller
                    name={searchAdvancedFiltersFields.binTrackingNumber.name}
                    control={control}
                    render={({ field }) => (
                        <Textarea
                            {...field}
                            className="flex-2 advanced-filters-field"
                        />
                    )}
                />
            </div>
            <div className="advanced-filters-row -align-start">
                <div className="advanced-filters-name flex-1">{searchAdvancedFiltersFields.trackingNumbers.label}</div>
                <Controller
                    name={searchAdvancedFiltersFields.trackingNumbers.name}
                    control={control}
                    render={({ field }) => (
                        <Textarea
                            {...field}
                            className="flex-2 advanced-filters-field"
                        />
                    )}
                />
            </div>
            <div className="advanced-filters-row -align-start">
                <div className="advanced-filters-name flex-1">{searchAdvancedFiltersFields.supplier.label}</div>
                <Controller
                    name={searchAdvancedFiltersFields.supplier.name}
                    control={control}
                    render={({ field }) => (
                        <Textarea
                            {...field}
                            className="flex-2 advanced-filters-field"
                        />
                    )}
                />
            </div>
            <div className="advanced-filters-row -align-start">
                <div className="advanced-filters-name flex-1">{searchAdvancedFiltersFields.internalSupplierId.label}</div>
                <Controller
                    name={searchAdvancedFiltersFields.internalSupplierId.name}
                    control={control}
                    render={({ field }) => (
                        <Textarea
                            {...field}
                            className="flex-2 advanced-filters-field"
                        />
                    )}
                />
            </div>
            <div className="advanced-filters-row -align-start">
                <div className="advanced-filters-name flex-1">{searchAdvancedFiltersFields.correlationId.label}</div>
                <Controller
                    name={searchAdvancedFiltersFields.correlationId.name}
                    control={control}
                    render={({ field }) => (
                        <Textarea
                            {...field}
                            className="flex-2 advanced-filters-field"
                        />
                    )}
                />
            </div>
            <div className="advanced-filters-row">
                <div className="advanced-filters-name flex-1">Received Date</div>
                <div className="flex flex-2 advanced-filters-field">
                    <Controller
                        name={advancedFiltersDateFields.startCreateDate.name}
                        control={control}
                        render={({ field }) => {
                            return (
                                <DatePicker
                                    emitAsString
                                    className="m-r-16"
                                    isClearable
                                    label={advancedFiltersDateFields.startCreateDate.label}
                                    name={field.name}
                                    value={field.value}
                                    updateOnChange={(name, value) => field.onChange(value)}
                                    enableIcon
                                />
                            );
                        }}
                    />
                    <Controller
                        name={advancedFiltersDateFields.endCreateDate.name}
                        control={control}
                        render={({ field }) => (
                            <DatePicker
                                emitAsString
                                className="m-l-16"
                                isClearable
                                label={advancedFiltersDateFields.endCreateDate.label}
                                name={field.name}
                                enableIcon
                                value={field.value}
                                updateOnChange={(name, value) => field.onChange(value)}
                            />
                        )}
                    />
                </div>
            </div>
            <div className="advanced-filters-row">
                <div className="advanced-filters-name flex-1">Updated</div>
                <div className="flex flex-2 advanced-filters-field">
                    <Controller
                        name={advancedFiltersDateFields.startUpdatedOn.name}
                        control={control}
                        render={({ field }) => {
                            return (
                                <DatePicker
                                    emitAsString
                                    className="m-r-16"
                                    isClearable
                                    label={advancedFiltersDateFields.startUpdatedOn.label}
                                    name={field.name}
                                    value={field.value}
                                    updateOnChange={(name, value) => field.onChange(value)}
                                    enableIcon
                                />
                            );
                        }}
                    />
                    <Controller
                        name={advancedFiltersDateFields.endUpdatedOn.name}
                        control={control}
                        render={({ field }) => (
                            <DatePicker
                                emitAsString
                                className="m-l-16"
                                isClearable
                                label={advancedFiltersDateFields.endUpdatedOn.label}
                                name={field.name}
                                enableIcon
                                value={field.value}
                                updateOnChange={(name, value) => field.onChange(value)}
                            />
                        )}
                    />
                </div>
            </div>
            <div className="advanced-filters-row">
                <div className="advanced-filters-name flex-1">Due Date</div>
                <div className="flex flex-2 advanced-filters-field">
                    <Controller
                        name={advancedFiltersDateFields.startShipmentDueDate.name}
                        control={control}
                        render={({ field }) => {
                            return (
                                <DatePicker
                                    emitAsString
                                    className="m-r-16"
                                    isClearable
                                    label={advancedFiltersDateFields.startShipmentDueDate.label}
                                    name={field.name}
                                    value={field.value}
                                    updateOnChange={(name, value) => field.onChange(value)}
                                    enableIcon
                                />
                            );
                        }}
                    />
                    <Controller
                        name={advancedFiltersDateFields.endShipmentDueDate.name}
                        control={control}
                        render={({ field }) => (
                            <DatePicker
                                emitAsString
                                className="m-l-16"
                                isClearable
                                label={advancedFiltersDateFields.endShipmentDueDate.label}
                                name={field.name}
                                enableIcon
                                value={field.value}
                                updateOnChange={(name, value) => field.onChange(value)}
                            />
                        )}
                    />
                </div>
            </div>
            <div className="advanced-filters-row">
                <div className="advanced-filters-name flex-1">{searchAdvancedFiltersFields.status.label}</div>
                <Controller
                    name={searchAdvancedFiltersFields.status.name}
                    control={control}
                    render={({ field }) => (
                        <Select
                            {...field}
                            className="flex-2 advanced-filters-field"
                            excludeSelect={false}
                            value={(field && field.value) || ""}
                            options={statusBooleanOptions}
                        />
                    )}
                />
            </div>
        </>
    );
};
